export const CONFACL_CREATE_RESET = 'CONFACL_CREATE_RESET'
export const CONFACL_CREATE_SET_CREATED = 'CONFACL_CREATE_SET_CREATED'
export const CONFACL_CREATE_SET_ERROR = 'CONFACL_CREATE_SET_ERROR'
export const CONFACL_CREATE_SET_VIOLATIONS = 'CONFACL_CREATE_SET_VIOLATIONS'
export const CONFACL_CREATE_TOGGLE_LOADING = 'CONFACL_CREATE_TOGGLE_LOADING'
